(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9521],{

/***/ 23257:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var apiToAlert = function apiToAlert(apiError) {
  return {
    analyticsLabel: apiError.response || "API returned ".concat(JSON.stringify(apiError)),
    children: apiError.explanation || 'Oh no!',
    heading: apiError.response || 'Something went wrong',
    level: apiError.level || 'danger'
  };
};
var _default = exports["default"] = apiToAlert;
module.exports = exports.default;

/***/ }),

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 86151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tax",
      function () {
        return __webpack_require__(18378);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 18378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/get-income-type-from-scale/index.js
var get_income_type_from_scale = __webpack_require__(11845);
var get_income_type_from_scale_default = /*#__PURE__*/__webpack_require__.n(get_income_type_from_scale);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/components/all-products-data-loader/index.ts
var all_products_data_loader = __webpack_require__(76988);
// EXTERNAL MODULE: ./src/client/analytics/index.ts + 6 modules
var analytics = __webpack_require__(86039);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/get-agr-income-thresholds/index.js
var get_agr_income_thresholds = __webpack_require__(93831);
var get_agr_income_thresholds_default = /*#__PURE__*/__webpack_require__.n(get_agr_income_thresholds);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/utils/calculate-income-tier/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file
var calculateIncomeTier = function(param) {
    var scale = param.scale, income = param.income;
    var incomeType = get_income_type_from_scale_default()(scale);
    var thresholds = get_agr_income_thresholds_default()()[incomeType];
    var threshold = (0,fp.find)(function(obj) {
        return income >= obj.min && income <= obj.max;
    }, thresholds);
    var incomeTier = threshold.incomeTier;
    return incomeTier;
};
/* harmony default export */ var calculate_income_tier = (calculateIncomeTier);

;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/utils/get-mls-threshold/index.ts



/**
 * Get the MLS threshold and rate based on scale and income.
 *
 * NOTE: The number of dependants can effect the amount paid if more than 1 dependent.
 * We are assuming they have less than 2 dependents and show a disclaimer advising them of this.
 * Check the blame history to see this logic if you need it in future.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale.
 * @param {number} customer.income - Customer income.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var getMlsThreshold = function(param) {
    var scale = param.scale, income = param.income;
    var incomeType = get_income_type_from_scale_default()(scale);
    var thresholds = get_agr_income_thresholds_default()()[incomeType];
    return (0,fp.find)(function(obj) {
        return income >= obj.min && income <= obj.max;
    }, thresholds);
};
/* harmony default export */ var get_mls_threshold = (getMlsThreshold);

;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/utils/calculate-mls/index.ts

/**
 * Calculate the MLS amount based on scale and income.
 *
 * NOTE: The number of dependants can effect the amount paid if more than 1 dependent.
 * We are assuming they have less than 2 dependents and show a disclaimer advising them of this.
 * Check the blame history to see this logic if you need it in future.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale.
 * @param {number} customer.income - Customer income.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var calculateMls = function(param) {
    var scale = param.scale, income = param.income;
    var rate = get_mls_threshold({
        income: income,
        scale: scale
    }).rate;
    return income * rate / 100;
};
/* harmony default export */ var calculate_mls = (calculateMls);

// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/analytics/element.ts
var analytics_element = __webpack_require__(82758);
// EXTERNAL MODULE: ./src/client/utils/get-scale-options/index.tsx
var get_scale_options = __webpack_require__(94562);
// EXTERNAL MODULE: ./src/client/pages/campaigns/tax-time/components/calculator/components/mls-slider-tip/styles.module.sass
var styles_module = __webpack_require__(68255);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/calculator/components/mls-slider-tip/index.tsx





// @ts-expect-error - Automatic, Please fix when editing this file
var getIncomeTypeText = function(scale) {
    return get_income_type_from_scale_default()(scale) === "single" ? "single income" : "family income";
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getValueText = function(value, param) {
    var max = param.max, min = param.min;
    if (value < min) {
        return "Under $".concat(min, ",000");
    }
    if (value > max) {
        return "Over $".concat(max, ",000");
    }
    return "$".concat(value, ",000");
};
var MlsSliderTip = function(param) {
    var limits = param.limits, scale = param.scale, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                    variant: (styles_module_default()).value,
                    children: getValueText(value, limits)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: getIncomeTypeText(scale)
            })
        ]
    });
};
/* harmony default export */ var mls_slider_tip = (MlsSliderTip);


// EXTERNAL MODULE: ./src/client/pages/campaigns/tax-time/components/calculator/styles.module.sass
var calculator_styles_module = __webpack_require__(43738);
var calculator_styles_module_default = /*#__PURE__*/__webpack_require__.n(calculator_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/calculator/index.tsx


















var amountToDrop = 1;
var radix = 10;
var DROPDOWN_PROPS = {
    size: "auto",
    type: "dropdown"
};
var scaleOptions = (0,get_scale_options/* default */.Z)();
var bindActionToEvent = // @ts-expect-error - Automatic, Please fix when editing this file
function(actionFunction) {
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(param) {
        var value = param.target.value;
        actionFunction(value);
    });
};
// @ts-expect-error - Automatic, Please fix when editing this file
var analyticsFnGenerator = function(label, fn, type) {
    return (0,analytics_element/* default */.Z)({
        analytics: {
            component: "TaxCalculator",
            label: label
        }
    }, type === "event" ? bindActionToEvent(fn) : fn);
};
var tipFormatterGenerator = // @ts-expect-error - Automatic, Please fix when editing this file
function(param) {
    var limits = param.limits, scale = param.scale;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(value) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mls_slider_tip, {
            limits: limits,
            scale: scale,
            value: value
        });
    });
};
var calculateSliderProps = (0,fp.memoize)(function(scale) {
    var incomeType = get_income_type_from_scale_default()(scale);
    var isSingleIncome = incomeType === ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE;
    var thresholds = get_agr_income_thresholds_default()()[incomeType];
    var marks = {};
    (0,fp.forEach)(function(threshold) {
        // @ts-expect-error - Automatic, Please fix when editing this file
        var mark = threshold.max / 1000;
        // @ts-expect-error - Automatic, Please fix when editing this file
        marks[mark] = "".concat(mark.toString(), "k");
    }, (0,fp.dropRight)(amountToDrop, thresholds));
    // @ts-expect-error - Automatic, Please fix when editing this file
    var firstMark = (0,fp.head)(thresholds).max / 1000;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var lastMark = (0,fp.last)(thresholds).min / 1000;
    var min = firstMark - (isSingleIncome ? 15 : 30);
    var max = lastMark + (isSingleIncome ? 15 : 30);
    return {
        firstMark: firstMark,
        lastMark: lastMark,
        marks: marks,
        max: max,
        min: min
    };
});
var Calculator = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Calculator, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Calculator);
    function Calculator() {
        (0,_class_call_check/* default */.Z)(this, Calculator);
        var _this;
        _this = _super.apply(this, arguments);
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.onSliderChange = function(value) {
            var _props = _this.props, customer = _props.customer, onChange = _props.onChange;
            // @ts-expect-error - Automatic, Please fix when editing this file
            var ref = calculateSliderProps(customer.scale), firstMark = ref.firstMark, lastMark = ref.lastMark;
            // We clamp income for the mls calculation because we want a nice round number for the calculator results,
            // but we use the unclamped income for the income tier calculation because we want it work for rebate tier 3 (which starts at $140,001).
            var income = value * 1000;
            var clampedIncome = (0,fp.clamp)(firstMark * 1000, lastMark * 1000, income);
            // @ts-expect-error - Automatic, Please fix when editing this file
            _this.onIncomeChange(income);
            var mlsAmount = calculate_mls({
                income: clampedIncome,
                // @ts-expect-error - Automatic, Please fix when editing this file
                scale: customer.scale
            });
            var incomeTier = calculate_income_tier({
                income: income,
                // @ts-expect-error - Automatic, Please fix when editing this file
                scale: customer.scale
            });
            onChange({
                income: income,
                incomeTier: incomeTier,
                mlsAmount: mlsAmount,
                // @ts-expect-error - Automatic, Please fix when editing this file
                scale: customer.scale,
                // @ts-expect-error - Automatic, Please fix when editing this file
                state: customer.state
            });
        };
        return _this;
    }
    var _proto = Calculator.prototype;
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidMount = function componentDidMount() {
        // We throttle redux action/reducer/render to improve front end performance.
        // This assumes income is not needed for in-page rendering,
        // but only for maintaining customer state data and analytics purposes.
        var _props = this.props, onIncomeChange = _props.onIncomeChange, onScaleChange = _props.onScaleChange, onStateChange = _props.onStateChange;
        // @ts-expect-error - Automatic, Please fix when editing this file
        this.onIncomeChange = (0,fp.debounce)(500, function(value) {
            return onIncomeChange(value);
        });
        // @ts-expect-error - Automatic, Please fix when editing this file
        this.onScaleChange = analyticsFnGenerator("scale", onScaleChange, "event");
        // @ts-expect-error - Automatic, Please fix when editing this file
        this.onStateChange = analyticsFnGenerator("state", onStateChange, "event");
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevCustomer = prevProps.customer;
        var customer = this.props.customer;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var incomeTypes = [
            customer.incomeType,
            prevCustomer.incomeType
        ];
        if ((0,fp.uniq)(incomeTypes).length === 2 && (0,fp.includes)(ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE, incomeTypes)) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            var marks = calculateSliderProps(customer.scale);
            // @ts-expect-error - Automatic, Please fix when editing this file
            this.onSliderChange((0,fp.parseInt)(radix, marks.min));
        }
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.render = function render() {
        var customer = this.props.customer;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var ref = calculateSliderProps(customer.scale), firstMark = ref.firstMark, lastMark = ref.lastMark, marks = ref.marks, max = ref.max, min = ref.min;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var isSingleIncome = customer.incomeType === ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (calculator_styles_module_default()).calculator,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (calculator_styles_module_default()).fieldsWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            looksLike: "h4",
                            variant: "regular",
                            children: "If you’re a"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (calculator_styles_module_default()).field,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DROPDOWN_PROPS), {
                                ariaLabel: "scale",
                                name: "scale",
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                onChange: this.onScaleChange,
                                options: scaleOptions,
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                value: customer.scale
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            looksLike: "h4",
                            variant: "regular",
                            children: "in"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (calculator_styles_module_default()).field,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Field */.gN, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, DROPDOWN_PROPS), {
                                ariaLabel: "state",
                                name: "state",
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                onChange: this.onStateChange,
                                options: ahm_constants/* default.STATE_OPTIONS */.Z.STATE_OPTIONS,
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                value: customer.state
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                            looksLike: "h4",
                            variant: "regular",
                            children: "and earning"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (calculator_styles_module_default()).sliderContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Slider */.iR, {
                        analytics: {
                            action: "on_tax_income_move_slider",
                            component: "tax"
                        },
                        marks: marks,
                        max: max,
                        min: min,
                        name: "income",
                        onChange: this.onSliderChange,
                        tipFormatter: tipFormatterGenerator({
                            limits: {
                                max: Math.floor(lastMark),
                                min: Math.floor(firstMark)
                            },
                            // @ts-expect-error - Automatic, Please fix when editing this file
                            scale: customer.scale
                        }),
                        ariaLabelForHandle: "income",
                        ariaValueTextFormatterForHandle: function() {
                            var ref;
                            return customer === null || customer === void 0 ? void 0 : (ref = customer.income) === null || ref === void 0 ? void 0 : ref.toString();
                        }
                    }, isSingleIncome ? "slider-single" : "slider-couple")
                })
            ]
        });
    };
    return Calculator;
}(react.PureComponent);
// @ts-expect-error - Automatic, Please fix when editing this file
Calculator.defaultProps = {
    customer: null,
    onIncomeChange: null,
    onScaleChange: null,
    onStateChange: null
};
/* harmony default export */ var calculator = (Calculator);


;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/calculator-section/components/calculator-results/index.tsx



var CalculatorResults = function(param) {
    var amount = param.amount;
    var children = amount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
        children: "Good news, looks like you might not have to pay\xa0the\xa0MLS!"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H3, {
                children: [
                    "You might have to pay about $",
                    amount.toFixed(2),
                    " extra in tax"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                looksLike: "h3",
                variant: "regular",
                children: "without hospital cover for a full\xa0tax\xa0year."
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
        variant: "center",
        children: children
    });
};
/* harmony default export */ var calculator_results = (CalculatorResults);

;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/calculator-section/utils/get-prefix-sentence/index.ts

/**
 * Get a sentence describing the MLS that has been applied.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale.
 * @param {number} customer.income - Customer income.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var getPrefixSentence = function(param) {
    var income = param.income, scale = param.scale;
    var threshold = get_mls_threshold({
        income: income,
        scale: scale
    });
    var ref;
    if (((ref = threshold === null || threshold === void 0 ? void 0 : threshold.rate) !== null && ref !== void 0 ? ref : 0) <= 0) {
        return null;
    }
    return "".concat(threshold.rate, "% MLS applying to");
};
/* harmony default export */ var get_prefix_sentence = (getPrefixSentence);

// EXTERNAL MODULE: ./src/client/utils/get-income-tier-options/index.ts
var get_income_tier_options = __webpack_require__(2001);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/calculator-section/utils/get-scale-table-data/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file
var getDataForTier = function(incomeTier, tiers) {
    return (0,fp.find)({
        value: incomeTier
    })(tiers);
};
var getScaleTableData = function() {
    var forceDate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var singlesTiers = (0,get_income_tier_options/* default */.Z)({
        forceDate: forceDate,
        incomeType: ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE,
        isCompact: true
    });
    var couplesTiers = (0,get_income_tier_options/* default */.Z)({
        forceDate: forceDate,
        incomeType: ahm_constants/* default.INCOME_TYPE.COUPLE */.Z.INCOME_TYPE.COUPLE,
        isCompact: true
    });
    var singlesTier0 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_0 */.Z.INCOME_TIER.TIER_0, singlesTiers);
    var singlesTier1 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_1 */.Z.INCOME_TIER.TIER_1, singlesTiers);
    var singlesTier2 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_2 */.Z.INCOME_TIER.TIER_2, singlesTiers);
    var singlesTier3 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_3 */.Z.INCOME_TIER.TIER_3, singlesTiers);
    var couplesTier0 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_0 */.Z.INCOME_TIER.TIER_0, couplesTiers);
    var couplesTier1 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_1 */.Z.INCOME_TIER.TIER_1, couplesTiers);
    var couplesTier2 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_2 */.Z.INCOME_TIER.TIER_2, couplesTiers);
    var couplesTier3 = getDataForTier(ahm_constants/* default.INCOME_TIER.TIER_3 */.Z.INCOME_TIER.TIER_3, couplesTiers);
    return [
        {
            // @ts-expect-error - Automatic, Please fix when editing this file
            couplesFamilies: "".concat(couplesTier0.text),
            // @ts-expect-error - Automatic, Please fix when editing this file
            mls: singlesTier0.rate,
            // @ts-expect-error - Automatic, Please fix when editing this file
            singles: singlesTier0.text
        },
        {
            // @ts-expect-error - Automatic, Please fix when editing this file
            couplesFamilies: couplesTier1.text,
            // @ts-expect-error - Automatic, Please fix when editing this file
            mls: singlesTier1.rate,
            // @ts-expect-error - Automatic, Please fix when editing this file
            singles: singlesTier1.text
        },
        {
            // @ts-expect-error - Automatic, Please fix when editing this file
            couplesFamilies: couplesTier2.text,
            // @ts-expect-error - Automatic, Please fix when editing this file
            mls: singlesTier2.rate,
            // @ts-expect-error - Automatic, Please fix when editing this file
            singles: singlesTier2.text
        },
        {
            // @ts-expect-error - Automatic, Please fix when editing this file
            couplesFamilies: couplesTier3.text,
            // @ts-expect-error - Automatic, Please fix when editing this file
            mls: singlesTier3.rate,
            // @ts-expect-error - Automatic, Please fix when editing this file
            singles: singlesTier3.text
        }, 
    ];
};
/* harmony default export */ var get_scale_table_data = (getScaleTableData);

// EXTERNAL MODULE: ./src/client/pages/campaigns/tax-time/components/calculator-section/styles.module.sass
var calculator_section_styles_module = __webpack_require__(84514);
var calculator_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(calculator_section_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/calculator-section/index.tsx













var scaleTable = {
    columns: [
        {
            colProps: {
                df: 4,
                sm: 4
            },
            header: "Singles",
            key: "singles"
        },
        {
            colProps: {
                df: 5,
                sm: 4
            },
            header: "Couples, Families and single parents",
            key: "couplesFamilies"
        },
        {
            colProps: {
                df: 3
            },
            header: "Medicare Levy Surcharge",
            key: "mls"
        }, 
    ],
    // @ts-expect-error - Automatic, Please fix when editing this file
    data: get_scale_table_data("2024-06-30T00:00:00+10:00"),
    variant: [
        "rowBorders",
        "rowPadding"
    ]
};
var CalculatorSection = function(_param) /*#__PURE__*/ {
    var mlsAmount = _param.mlsAmount, incomeType = _param.incomeType, calculatorProps = (0,_object_without_properties/* default */.Z)(_param, [
        "mlsAmount",
        "incomeType"
    ]);
    return (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
        className: (calculator_section_styles_module_default()).calculatorWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                    df: 8,
                    dfOffset: 2,
                    sm: 12,
                    smOffset: 0,
                    variant: "marginBottomSpacer1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                            variant: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                    variant: "marginBottomSpacer4",
                                    children: "How much extra tax could you\xa0be\xa0paying?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: "The Medicare Levy Surcharge (MLS) is set by the Government and is designed to make health care more affordable to more Australians. But if you earn more than the relevant income threshold, and don’t have an appropriate level of private hospital cover, it could be costing you extra in tax."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                    children: [
                                        "Depending on your income over a full financial year, you might have to pay the MLS which can be an extra 1%, 1.25% or 1.5% of your income on top of your annual income tax.",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                            children: "See table below to find your income threshold."
                                        }),
                                        " Find out more at",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                            to: "https://www.ato.gov.au/individuals-and-families/medicare-and-private-health-insurance/medicare-levy-surcharge/medicare-levy-surcharge-income-thresholds-and-rates",
                                            children: "ato.gov.au."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                            variant: [
                                "marginTopSpacer8",
                                "marginBottomSpacer10"
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                children: "2024-2025 MLS Income thresholds (from 1 July 2024 onwards)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                            variant: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Table */.iA, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, scaleTable), {
                                    data: get_scale_table_data("2024-07-01T00:00:00+10:00")
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                    className: (calculator_section_styles_module_default()).paragraphBreak,
                                    children: [
                                        "If you have two or more MLS dependant children, the threshold will increase by $1,500 for each MLS dependant child after your first child. Find out more at",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                            to: "https://www.ato.gov.au/Individuals/Medicare-and-private-health-insurance/Medicare-levy-surcharge/Family-and-dependants-for-Medicare-levy-surcharge-purposes/",
                                            children: "ato.gov.au."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                        children: "Use the calculator below to see how the MLS could affect you."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    children: "Please note the below calculations apply from 1 July 2024 onwards. If you’re unsure whether the MLS applies to you, you should speak to a financial advisor."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: 10,
                    dfOffset: 1,
                    variant: "marginBottomSpacer2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calculator, (0,_object_spread/* default */.Z)({}, calculatorProps))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: 8,
                    dfOffset: 2,
                    sm: 12,
                    smOffset: 0,
                    variant: "marginBottomSpacer8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(calculator_results, {
                        amount: mlsAmount
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: 8,
                    dfOffset: 2,
                    sm: 12,
                    smOffset: 0,
                    variant: "marginBottomSpacer2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                        variant: "center",
                        children: [
                            incomeType === ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                children: [
                                    "This is a guide only. It is based on ",
                                    get_prefix_sentence(calculatorProps.customer),
                                    " the income you have selected and assumes you have no dependants^. You should speak to a financial advisor who will be able to take into account your income and personal situation, including any changes that occur during a tax year."
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                children: [
                                    "This is a guide only. It is based on ",
                                    get_prefix_sentence(calculatorProps.customer),
                                    " the family income you have selected and assumes you have 0-1 MLS dependent children^. Family income thresholds are increased by $1,500 for each MLS dependent child after the first child. So, if you have two MLS dependent children, the income threshold of $186,000 increases to $187,500 before you have to pay the MLS. You should speak to a financial advisor who will be able to take into account your income and personal situation, including any changes that occur during a tax year."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                children: [
                                    "^ ‘Income’ and ‘dependants’ have",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        to: ahm_constants/* default.URLS.THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE */.Z.URLS.THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE,
                                        children: "special meanings for MLS purposes"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
CalculatorSection.defaultProps = {
    customer: undefined,
    incomeType: ahm_constants/* default.INCOME_TYPE.SINGLE */.Z.INCOME_TYPE.SINGLE,
    mlsAmount: 0,
    onIncomeChange: fp.noop,
    onScaleChange: fp.noop,
    onStateChange: fp.noop
};
/* harmony default export */ var calculator_section = (CalculatorSection);

// EXTERNAL MODULE: ./src/client/actions/customer/index.ts
var customer = __webpack_require__(91395);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/utils/filter-hospital-services/index.ts

var filterHospitalServices = (0,fp.flow)((0,fp.sortBy)("rank"), (0,fp.take)(3));
/* harmony default export */ var filter_hospital_services = (filterHospitalServices);

;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/utils/get-recommended-product-ids/index.ts


/**
 * Get product ids for the recommended products on the tax page.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale ('single', 'couple', 'family' or 'single-parent').
 * @param {object} products - Products object keyed by productId.
 */ var getRecommendedProductIds = function(param, products) {
    var scale = param.scale;
    return (0,fp.filter)(function(productId) {
        var ref, ref1;
        return (0,fp.includes)(scale, products === null || products === void 0 ? void 0 : (ref = products[productId]) === null || ref === void 0 ? void 0 : (ref1 = ref.scales) === null || ref1 === void 0 ? void 0 : ref1.supported);
    }, [
        // TODO: AP-1293 Remove ESSENTIALS_BASIC_PLUS_EXCESS_750 and STARTER_BASIC_EXCESS_750 after go live
        // In the meantime ahm-logic is gatekeeping saleable/non-saleable list
        // NOTE: Order doesn't matter; products are sorted by rank in filterHospitalServices function
        ahm_constants/* default.PRODUCT.ESSENTIALS_BASIC_PLUS_EXCESS_750 */.Z.PRODUCT.ESSENTIALS_BASIC_PLUS_EXCESS_750,
        ahm_constants/* default.PRODUCT.CORE_HOSPITAL_BASIC_PLUS_EXCESS_750 */.Z.PRODUCT.CORE_HOSPITAL_BASIC_PLUS_EXCESS_750,
        ahm_constants/* default.PRODUCT.SIMPLE_BRONZE_PLUS_EXCESS_750 */.Z.PRODUCT.SIMPLE_BRONZE_PLUS_EXCESS_750,
        ahm_constants/* default.PRODUCT.STARTER_BASIC_EXCESS_750 */.Z.PRODUCT.STARTER_BASIC_EXCESS_750,
        ahm_constants/* default.PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750 */.Z.PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC_EXCESS_750,
        ahm_constants/* default.PRODUCT.STARTER_BRONZE_EXCESS_750 */.Z.PRODUCT.STARTER_BRONZE_EXCESS_750, 
    ]);
};
/* harmony default export */ var get_recommended_product_ids = (getRecommendedProductIds);

// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/components/legacy-bordered-wrapper/index.tsx
var legacy_bordered_wrapper = __webpack_require__(78558);
// EXTERNAL MODULE: ./src/client/models/price/load-price-for-component-props.ts
var load_price_for_component_props = __webpack_require__(14518);
// EXTERNAL MODULE: ./src/client/components/sections/accordion-section/index.tsx + 4 modules
var accordion_section = __webpack_require__(64323);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/other-savings/data.tsx




var otherSavingsData = [
    {
        analyticsLabel: "youth-discount",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "If you are 18 to 29 and a Principal member or partner, you might qualify for the Youth Discount on your private health insurance. The Youth Discount only applies to hospital cover or the hospital component of a package – it doesn’t apply to extras. If you keep continuous hospital cover, you’ll maintain the Youth Discount until you turn 41.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    analytics: {
                        label: "Youth Discount link"
                    },
                    to: ahm_constants/* default.URLS.SALES.YOUTH_DISCOUNT */.Z.URLS.SALES.YOUTH_DISCOUNT,
                    children: "Learn more about Youth Discount"
                })
            ]
        }),
        title: "Youth Discount"
    },
    {
        analyticsLabel: "agr",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "The Australian Government Rebate is an amount the government contributes towards health insurance premiums to make it more affordable. If you’re eligible, you can choose to get the rebate upfront by paying reduced premiums or it can be refunded as a tax offset when you lodge your tax return.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    inNewTab: true,
                    analytics: {
                        label: "What is AGR link"
                    },
                    to: ahm_constants/* default.URLS.HELP.WHAT_IS_AGR */.Z.URLS.HELP.WHAT_IS_AGR,
                    children: "Learn more about the AGR"
                })
            ]
        }),
        title: "The Australian Government Rebate (AGR) on private health insurance"
    },
    {
        analyticsLabel: "lhc",
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Lifetime Health Cover (LHC) loading is to encourage Australians to take out hospital cover early, by charging you extra if you take out hospital cover after 1 July following your 31st birthday. Join ahm before then and you can lose the loading.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                    inNewTab: true,
                    analytics: {
                        label: "What is LHC link"
                    },
                    to: ahm_constants/* default.URLS.HELP.WHAT_IS_LHC */.Z.URLS.HELP.WHAT_IS_LHC,
                    children: "Learn more about LHC loading"
                })
            ]
        }),
        title: "Lifetime Health Cover (LHC) loading"
    }, 
];
/* harmony default export */ var data = (otherSavingsData);

// EXTERNAL MODULE: ./src/client/pages/campaigns/tax-time/components/other-savings/styles.module.sass
var other_savings_styles_module = __webpack_require__(6069);
var other_savings_styles_module_default = /*#__PURE__*/__webpack_require__.n(other_savings_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/other-savings/index.tsx






var OtherSavings = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
        className: (other_savings_styles_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_section/* default */.Z, {
            accordionId: "tax-other-savings",
            items: data,
            title: "Other ways you could save with health insurance",
            image: null
        })
    });
};
/* harmony default export */ var other_savings = (OtherSavings);

// EXTERNAL MODULE: ./src/client/components/premium-review-toggle-wrapper/index.tsx + 2 modules
var premium_review_toggle_wrapper = __webpack_require__(12224);
// EXTERNAL MODULE: ./src/client/utils/prepare-product-for-product-tile/index.ts
var prepare_product_for_product_tile = __webpack_require__(59794);
// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/components/pricing-drawer/index.tsx + 7 modules
var pricing_drawer = __webpack_require__(87022);
// EXTERNAL MODULE: ./src/client/actions/product/index.ts
var product = __webpack_require__(15311);
// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var models_product = __webpack_require__(43735);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
// EXTERNAL MODULE: ./src/client/pages/campaigns/tax-time/components/products-section/styles.module.sass
var products_section_styles_module = __webpack_require__(47288);
var products_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(products_section_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/components/products-section/index.tsx












var ProductsSection = function(param) {
    var isLoadingPrice = param.isLoadingPrice, mlsAmount = param.mlsAmount, products = param.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* SpacerWrapper */.Cj, {
        variant: (products_section_styles_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: 12,
                    variant: "marginBottomSpacer9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                        variant: "center",
                        children: mlsAmount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                            children: "Here are some ahm products that might help with tax"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                                    children: "Having hospital cover is still a great idea."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                                    looksLike: "h3",
                                    variant: "regular",
                                    children: "Get started with…"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_section_styles_module_default()).productTiles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* AxisSwitcher */.e$, {
                    limit: 3,
                    space: "1rem",
                    threshold: "40rem",
                    children: (0,fp.map)(function(_param) /*#__PURE__*/ {
                        var content = _param.content, url = _param.url, restOfProps = (0,_object_without_properties/* default */.Z)(_param, [
                            "content",
                            "url"
                        ]);
                        return (0,jsx_runtime.jsx)("div", {
                            className: (products_section_styles_module_default()).productTileWrapper,
                            children: /*#__PURE__*/ (0,react.createElement)(ahm_ui/* ProductTile */.vB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restOfProps), {
                                ctaVariant: [
                                    "white",
                                    "border"
                                ],
                                isLoadingPrice: isLoadingPrice,
                                key: url,
                                linkTo: url,
                                blurb: (0,fp.get)("longForm")(content),
                                variant: (products_section_styles_module_default()).productTile
                            }))
                        }, url);
                    })(products)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        variant: (products_section_styles_module_default()).buttonWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                            to: "".concat(ahm_constants/* default.URLS.SALES.PRODUCT_LISTING */.Z.URLS.SALES.PRODUCT_LISTING, "/").concat(src.CUSTOMER_NEEDS.TAX, "/").concat(src.NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL),
                            variant: (products_section_styles_module_default()).cta,
                            children: "Compare covers"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: 12,
                        variant: "marginBottomSpacer8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (products_section_styles_module_default()).disclaimerContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price_disclaimer/* default */.ZP, {
                                bold: true,
                                showRefineLink: true,
                                constrainWidth: true,
                                forProducts: products,
                                center: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                        df: 12,
                        variant: (products_section_styles_module_default()).buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                                xs: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (products_section_styles_module_default()).or,
                                    children: "Also interested in extras cover?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                to: ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_PACKAGES */.Z.URLS.SALES.PRODUCT_LISTING_PACKAGES,
                                variant: [
                                    "border",
                                    "white"
                                ],
                                children: "View hospital & extras cover"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
ProductsSection.defaultProps = {
    isLoadingPrice: false,
    mlsAmount: 0
};
/* harmony default export */ var products_section = (ProductsSection);

// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/pages/campaigns/tax-time/styles.module.sass
var tax_time_styles_module = __webpack_require__(58779);
var tax_time_styles_module_default = /*#__PURE__*/__webpack_require__.n(tax_time_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/campaigns/tax-time/index.tsx






























var FREQUENCY = ahm_constants/* default.PAYMENT_FREQUENCY.YEARLY */.Z.PAYMENT_FREQUENCY.YEARLY;
var trackCalculatorAnalyticOnce = (0,fp.once)(function() {
    analytics/* default.publish */.Z.publish("action", {
        action: "Interacted",
        component: "TaxCalculator",
        label: "Calculator"
    });
});
var TaxTime = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TaxTime, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TaxTime);
    function TaxTime() {
        (0,_class_call_check/* default */.Z)(this, TaxTime);
        var _this;
        _this = _super.apply(this, arguments);
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.state = {
            mlsAmount: undefined
        };
        // @ts-expect-error - Automatic, Please fix when editing this file
        _this.calculatorChangeHandler = function(values) {
            var actions = _this.props.actions;
            var incomeTier = values.incomeTier;
            // @ts-expect-error - Automatic, Please fix when editing this file
            var _state = _this.state, currentIncome = _state.incomeTier;
            if (incomeTier !== currentIncome) {
                // @ts-expect-error - Automatic, Please fix when editing this file
                actions.customer.changeIncomeTier(incomeTier);
            }
            _this.setState(values);
            trackCalculatorAnalyticOnce();
        };
        return _this;
    }
    var _proto = TaxTime.prototype;
    /* eslint-disable-next-line react/sort-comp */ // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _props = this.props, actions = _props.actions, customer = _props.customer;
        if (!customer.state) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            actions.customer.changeState();
        }
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidMount = function componentDidMount() {
        var actions = this.props.actions;
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.customer.changeFrequency(FREQUENCY);
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.customer.changeHospitalExcess("750");
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.customer.changeIncome(null);
        // @ts-expect-error - Automatic, Please fix when editing this file
        actions.customer.changeIncomeTier(ahm_constants/* default.INCOME_TIER.TIER_0 */.Z.INCOME_TIER.TIER_0);
        // @ts-expect-error - Automatic, Please fix when editing this file
        load_price_for_component_props/* default.componentDidMount */.Z.componentDidMount(this.props);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        load_price_for_component_props/* default.componentWillReceiveProps */.Z.componentWillReceiveProps(prevProps, this.props);
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    _proto.render = function render() {
        var _props = this.props, actions = _props.actions, customer = _props.customer, isLoadingPrice = _props.isLoadingPrice, products = _props.products, prices = _props.prices, useFutureEffectiveDate = _props.useFutureEffectiveDate;
        var mlsAmount = this.state.mlsAmount;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var getFilteredProducts = function(allProducts) {
            if ((0,fp.size)(allProducts) < 3) {
                return null;
            }
            // @ts-expect-error - Automatic, Please fix when editing this file
            var recommendedProductIds = get_recommended_product_ids(customer, products);
            var recommendedProducts = models_product/* default.getProducts */.Z.getProducts(allProducts, recommendedProductIds);
            var preparedProducts = (0,fp.map)((0,prepare_product_for_product_tile/* default */.Z)({
                customer: customer,
                frequency: FREQUENCY,
                mlsAmount: mlsAmount,
                prices: prices,
                useFutureEffectiveDate: useFutureEffectiveDate
            }))(recommendedProducts);
            return filter_hospital_services(preparedProducts);
        };
        var incomeType = get_income_type_from_scale_default()(customer.scale);
        var filteredProducts = getFilteredProducts(products);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(legacy_bordered_wrapper/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: "Tax & hospital cover | Medicare Levy Surcharge"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: "Learn about whether private health insurance or the Medicare Levy Surcharge could affect your tax. Read more."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* FullScreenHeader */.Ld, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: "Tax & hospital cover"
                    }),
                    subtitle: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.P, {
                        children: "The Medicare Levy Surcharge (MLS) could be costing you extra in tax. ahm has hospital cover options that could help you save on the surcharge. Find out if the surcharge applies to you."
                    }),
                    scrollToElementId: "calculator",
                    scrollToElementText: "The ins and outs of tax & hospital cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "calculator",
                    children: (0,fp.isArray)(filteredProducts) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* BorderBox */.xw, {
                        variant: [
                            "paddingTopSpacer3",
                            "paddingBottomSpacer3",
                            "thin",
                            (tax_time_styles_module_default()).withDollarSignsBackground
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(calculator_section, {
                                customer: customer,
                                incomeType: incomeType,
                                mlsAmount: mlsAmount,
                                onChange: this.calculatorChangeHandler,
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                onIncomeChange: actions.customer.changeIncome,
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                onScaleChange: actions.customer.changeScale,
                                // @ts-expect-error - Automatic, Please fix when editing this file
                                onStateChange: actions.customer.changeState
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(premium_review_toggle_wrapper/* default */.ZP, {
                                type: "alternativePage",
                                hasEvenSpacing: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_section, {
                                mlsAmount: mlsAmount,
                                products: filteredProducts,
                                isLoadingPrice: isLoadingPrice
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(other_savings, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_drawer/* default */.Z, {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    useFutureEffectiveDate: useFutureEffectiveDate,
                    isProductWithHospitalServices: true,
                    showIncomeOptions: false
                })
            ]
        });
    };
    return TaxTime;
}(react.PureComponent);
// @ts-expect-error - Automatic, Please fix when editing this file
TaxTime.defaultProps = {
    isLoadingPrice: false,
    products: null
};
var mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        isLoadingPrice: state.price.loading,
        prices: state.price.data,
        products: state.product.data,
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            customer: (0,redux/* bindActionCreators */.DE)(customer/* default */.Z, dispatch),
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch),
            product: (0,redux/* bindActionCreators */.DE)(product/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var tax_time = ((0,redux/* compose */.qC)(all_products_data_loader/* default */.Z, (0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps))(TaxTime));


;// CONCATENATED MODULE: ./pages/tax/index.page.ts

var __N_SSP = true;
/* harmony default export */ var index_page = (tax_time);


/***/ }),

/***/ 75586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23094);

var updateAccordionWithId = // @ts-expect-error - Automatic, Please fix when editing this file
function(param) {
    var id = param.id, openIndices = param.openIndices;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(dispatch) {
        dispatch({
            payload: {
                id: id,
                openIndices: openIndices
            },
            type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .ACCORDION_UPDATE_SELECTION */ .h8
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    updateAccordionWithId: updateAccordionWithId
});


/***/ }),

/***/ 15311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23094);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);



/**
 * Load products into state.
 *
 * @param {string|string[]} productIds - One or a list of product ids.
 * @returns {object} Action.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var array = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(productIds) ? [
        productIds
    ] : productIds;
    return {
        productIds: array,
        // @ts-expect-error - Automatic, Please fix when editing this file
        promise: function(api) {
            return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadProducts */ .Z.loadProducts(api, array);
        },
        types: [
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD */ .F9,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_SUCCESS */ .cx,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_FAIL */ .w2
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    load: load
});


/***/ }),

/***/ 82758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86039);



/**
 * Little helper fn that enabled analytics tracking per element.
 *
 * Usage:
 * `<MyElement onClick={elementAnalytics(this.props, this.props.onClick, 'clicked')} />`.
 *
 * @param {object} props - Element properties, e.g. {analytics: {label: 'foobar'}, name: 'firstName'}.
 * @param {Function} originalFn - Original fn to wrap with analytics call.
 * @param {string} action - Action, e.g. 'clicked' or 'changed'.
 */ var elementAnalytics = // @ts-expect-error - Automatic, Please fix when editing this file
function(props, originalFn) {
    var action = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "changed";
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var analytics = props.analytics, children = props.children, name = props.name;
        var linkText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(children) && !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(children) ? (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.startCase)(children) : undefined;
        var label = (analytics === null || analytics === void 0 ? void 0 : analytics.label) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.startCase)(name) || linkText;
        if (label) {
            var ref;
            ___WEBPACK_IMPORTED_MODULE_1__/* ["default"].publish */ .Z.publish("action", {
                action: action,
                component: (ref = analytics === null || analytics === void 0 ? void 0 : analytics.component) !== null && ref !== void 0 ? ref : "element",
                label: label
            });
        }
        // Original fn to wrap
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isFunction)(originalFn)) {
            originalFn.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args));
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (elementAnalytics);


/***/ }),

/***/ 76988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84076);
/* harmony import */ var _utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93216);
/* harmony import */ var _selectors_make_select_has_all_required_products_loaded__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42070);
/* harmony import */ var _selectors_select_products_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50359);




/* harmony default export */ __webpack_exports__["Z"] = ((0,_data_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    selectIsDataLoaded: (0,_selectors_make_select_has_all_required_products_loaded__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()),
    selectLoadingError: _selectors_select_products_error__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
}));


/***/ }),

/***/ 84076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ data_loader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/assert/assert.js
var assert = __webpack_require__(27596);
var assert_default = /*#__PURE__*/__webpack_require__.n(assert);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/api-to-alert/index.js
var api_to_alert = __webpack_require__(23257);
var api_to_alert_default = /*#__PURE__*/__webpack_require__.n(api_to_alert);
// EXTERNAL MODULE: ./src/client/components/loading-error-alert/styles.module.sass
var styles_module = __webpack_require__(7550);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/loading-error-alert/index.tsx







// @ts-expect-error - Automatic, Please fix when editing this file
var shouldShowLoadingErrorAlert = function(loadingError) {
    return (0,fp.isPlainObject)(loadingError);
};
var LoadingErrorAlert = function(param) {
    var loadingError = param.loadingError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, (0,_object_spread/* default */.Z)({}, api_to_alert_default()(loadingError)))
            })
        })
    });
};
/* harmony default export */ var loading_error_alert = (LoadingErrorAlert);


// EXTERNAL MODULE: ./src/client/components/loading-spinner/index.tsx
var loading_spinner = __webpack_require__(30950);
;// CONCATENATED MODULE: ./src/client/components/data-loader/index.tsx











var dataLoader = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // @ts-expect-error - Automatic, Please fix when editing this file
    assert_default()((0,fp.isFunction)(options.selectIsDataLoaded), "selectIsDataLoaded option must be a function");
    // @ts-expect-error - Automatic, Please fix when editing this file
    assert_default()((0,fp.isFunction)(options.selectLoadingError), "selectLoadingError option must be a function");
    // @ts-expect-error - Automatic, Please fix when editing this file
    var mapStateToProps = function(state, props) {
        return {
            // @ts-expect-error - Automatic, Please fix when editing this file
            isLoaded: options.selectIsDataLoaded(state, props),
            // @ts-expect-error - Automatic, Please fix when editing this file
            loadingError: options.selectLoadingError(state, props),
            state: state
        };
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    var mapDispatchToProps = function(dispatch) {
        return {
            dispatch: dispatch
        };
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(WrappedComponent) {
        var DataLoader = /*#__PURE__*/ function(PureComponent) {
            "use strict";
            (0,_inherits/* default */.Z)(DataLoader, PureComponent);
            var _super = (0,_create_super/* default */.Z)(DataLoader);
            function DataLoader() {
                (0,_class_call_check/* default */.Z)(this, DataLoader);
                return _super.apply(this, arguments);
            }
            var _proto = DataLoader.prototype;
            // DEPRECATED: not in use for server-side data fetching in NextJS
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                var _props = this.props, dispatch = _props.dispatch, history = _props.history, loadData = _props.loadData, match = _props.match, state = _props.state;
                // Define loadData prop in top-level routes config ('../../routes/index.jsx')
                if ((0,fp.isFunction)(loadData)) {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    loadData(state, dispatch, match.params, history);
                }
            };
            // DEPRECATED: not in use for server-side data fetching in NextJS
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
                if (prevProps.isLoaded && !this.props.isLoaded) {
                    var _props = this.props, dispatch = _props.dispatch, history = _props.history, loadData = _props.loadData, match = _props.match, state = _props.state;
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    loadData(state, dispatch, match.params, history);
                }
            };
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.render = function render() {
                var _props = this.props, isLoaded = _props.isLoaded, loadingError = _props.loadingError;
                if (!isLoaded) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
                }
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'timeout' does not exist on type '{ code?: string | undefined; explanation?: string | ReactElement<any, string | JSXElementConstructor<any>> | undefined; response?: string | undefined; }'.
                var errorToShow = (loadingError === null || loadingError === void 0 ? void 0 : loadingError.timeout) ? {
                    explanation: "It seems our servers are taking too long to respond. Please try again later."
                } : loadingError;
                if (shouldShowLoadingErrorAlert(errorToShow)) {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_error_alert, {
                        loadingError: errorToShow
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                    "dispatch",
                    "state"
                ], this.props)));
            };
            return DataLoader;
        }(react.PureComponent);
        // @ts-expect-error - Automatic, Please fix when editing this file
        DataLoader.defaultProps = {
            history: {
                push: fp.noop
            },
            isLoaded: false,
            loadData: null,
            loadingError: null,
            match: {
                params: {
                    id: null
                }
            }
        };
        return (0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(DataLoader);
    };
};
/* harmony default export */ var data_loader = (dataLoader);


/***/ }),

/***/ 78558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97189);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





// @ts-expect-error - Automatic, Please fix when editing this file
var LegacyBorderedWrapper = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? null : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
        size: "extraExtraLarge",
        isFullWidth: true,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().withBorders), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LegacyBorderedWrapper);


/***/ }),

/***/ 30950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90937);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
 * @deprecated If you need to display a transition state for the entire content of a page please
 * prefer LoadingContent to avoid breaking accessibility rules.
 */ var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().section),
        "data-testid": "loading-spinner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
                size: "large",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$j, {})
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingSpinner);


/***/ }),

/***/ 64323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accordion_section; }
});

// UNUSED EXPORTS: AccordionSectionForTest

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  @media (min-width: ",
        ") {\n    max-width: 35rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var isTwoColumn = param.isTwoColumn;
    return isTwoColumn && "\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n        gap: 2rem;\n    ";
});
var ColumnWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(props) {
    return props.isTwoColumn && "width: 50%;";
});
var AccordionContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.md;
}, function(param) {
    var isTwoColumn = param.isTwoColumn;
    return isTwoColumn && "\n       padding-top: 3rem;\n    ";
});
var SummaryWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-65b6abc1-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});

// EXTERNAL MODULE: ./src/client/actions/accordion/index.ts
var accordion = __webpack_require__(75586);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/components/accordion-image/index.tsx

function accordion_image_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    margin-bottom: 0;\n  }\n"
    ]);
    accordion_image_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5e2b6863-0"
})(accordion_image_templateObject(), function(param) {
    var isTwoColumn = param.isTwoColumn;
    return isTwoColumn && "\n      margin-bottom: 1rem;\n  ";
}, function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var AccordionImage = function(param) {
    var image = param.image, isTwoColumn = param.isTwoColumn;
    if (!image) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
        isTwoColumn: isTwoColumn,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
            src: image.src,
            alt: image.alt
        })
    });
};
/* harmony default export */ var accordion_image = (AccordionImage);

;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/utils/get-visible-accordion-items/index.ts

var getVisibleAccordionItems = function(param) {
    var isOpen = param.isOpen, items = param.items, initialVisible = param.initialVisible;
    if (!initialVisible) {
        return items;
    }
    var visibleItems = (0,fp.slice)(0, initialVisible, items);
    return isOpen ? items : visibleItems;
};
/* harmony default export */ var get_visible_accordion_items = (getVisibleAccordionItems);

// EXTERNAL MODULE: ./src/client/components/sections/accordion-section/styles.module.sass
var styles_module = __webpack_require__(74701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/components/wrap-item-body/index.tsx




// @ts-expect-error - Automatic, Please fix when editing this file
var wrapItemBody = function(body) {
    if (/*#__PURE__*/ react.isValidElement(body)) {
        return body;
    }
    if ((0,fp.isString)(body)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Markdown */.UG, {
            children: body
        });
    }
    if ((0,fp.isPlainObject)(body) || (0,fp.isArray)(body)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
            source: body
        });
    }
    return null;
};
/* harmony default export */ var wrap_item_body = (wrapItemBody);

// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/accordion-section/index.tsx















var AccordionSection = function(param) {
    var actions = param.actions, accordionId = param.accordionId, ariaLabelPrefix = param.ariaLabelPrefix, className = param.className, cta = param.cta, image = param.image, minimalBorder = param.minimalBorder, openIndices = param.openIndices, items = param.items, summary = param.summary, title = param.title, withBorder = param.withBorder, isTwoColumn = param.isTwoColumn, initialVisible = param.initialVisible, spacerSize = param.spacerSize;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    // @ts-expect-error - Automatic, Please fix when editing this file
    var itemsToDisplay = get_visible_accordion_items({
        initialVisible: initialVisible,
        isOpen: isOpen,
        items: items
    });
    // @ts-expect-error - Automatic, Please fix when editing this file
    var showSeeMore = initialVisible && items.length > initialVisible;
    var hasHeaderCopy = title || summary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        spacerSize: spacerSize,
        withBorder: withBorder,
        children: [
            !isTwoColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_image, {
                image: image
            }),
            hasHeaderCopy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                variant: "center",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                        variant: "marginBottomSpacer".concat(summary ? "8" : "6"),
                        children: title
                    }),
                    summary && /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            variant: "marginBottomSpacer8",
                            source: summary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                isTwoColumn: isTwoColumn,
                "data-testid": "content-wrapper",
                children: [
                    isTwoColumn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnWrapper, {
                        isTwoColumn: isTwoColumn,
                        "data-testid": "two-column-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_image, {
                            image: image,
                            isTwoColumn: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnWrapper, {
                        isTwoColumn: isTwoColumn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionContent, {
                            isTwoColumn: isTwoColumn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Accordion */.UQ, {
                                    className: className,
                                    id: accordionId,
                                    ariaLabelPrefix: ariaLabelPrefix,
                                    items: (0,fp.map)(function(item) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            body: wrap_item_body(item.body)
                                        });
                                    }, itemsToDisplay),
                                    updateSelection: function(newOpenIndices) {
                                        actions.accordion.updateAccordionWithId({
                                            id: accordionId,
                                            openIndices: newOpenIndices
                                        });
                                    },
                                    variant: [
                                        !minimalBorder && "fullBorder",
                                        "white"
                                    ],
                                    openIndices: openIndices
                                }),
                                !isOpen && showSeeMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* TypeWrapper */.f3, {
                                    variant: [
                                        "center",
                                        "marginTopSpacer8"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        icon: {
                                            fontWeight: "regular",
                                            name: "chevron-down",
                                            position: "right"
                                        },
                                        isUnstyled: true,
                                        onClick: function() {
                                            return setIsOpen(true);
                                        },
                                        children: "View more"
                                    })
                                }),
                                (cta === null || cta === void 0 ? void 0 : cta.title) && (cta === null || cta === void 0 ? void 0 : cta.to) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).cta,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                        icon: {
                                            fontWeight: "regular",
                                            name: "chevron-right",
                                            position: "right"
                                        },
                                        to: cta.to,
                                        children: cta.title
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
AccordionSection.defaultProps = {
    cta: null,
    image: null,
    initialVisible: null,
    items: [],
    openIndices: [],
    title: "",
    withBorder: false
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapStateToProps = function(state, param) {
    var accordionId = param.accordionId;
    var ref, ref1;
    return {
        openIndices: state === null || state === void 0 ? void 0 : (ref = state.accordion) === null || ref === void 0 ? void 0 : (ref1 = ref.openIndices) === null || ref1 === void 0 ? void 0 : ref1[accordionId]
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            accordion: (0,redux/* bindActionCreators */.DE)(accordion/* default */.Z, dispatch)
        }
    };
};
/* harmony default export */ var accordion_section = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(AccordionSection));



/***/ }),

/***/ 51878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42262);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





var WrappedSection = function(param) {
    var children = param.children, variant = param.variant, withBorder = param.withBorder, withInvert = param.withInvert, withWide = param.withWide, spacerSize = param.spacerSize;
    var section = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
        variant: [
            "paddingTopSpacer".concat(spacerSize),
            "paddingBottomSpacer".concat(spacerSize),
            (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().section),
            variant
        ],
        children: children
    });
    return withBorder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
            padding: "0",
            backgroundColor: withInvert ? "black" : "white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
                    (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().horizontalSpacingWrapper),
                    withInvert ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().invert) : null,
                    withWide ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wide) : null, 
                ]),
                children: section
            })
        })
    }) : section;
};
WrappedSection.defaultProps = {
    spacerSize: 3,
    variant: null,
    withBorder: false,
    withInvert: false,
    withWide: false
};
/* harmony default export */ __webpack_exports__["Z"] = (WrappedSection);


/***/ }),

/***/ 14518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93216);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43735);





// @ts-expect-error - Automatic, Please fix when editing this file
var componentDidMount = function(param) {
    var actions = param.actions, customer = param.customer, products = param.products, useFutureEffectiveDate = param.useFutureEffectiveDate;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flow)(function(productIds) {
        return _product__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProducts */ .Z.getProducts(products, productIds);
    }, function(productsArray) {
        return _product__WEBPACK_IMPORTED_MODULE_4__/* ["default"].filterAvailableProducts */ .Z.filterAvailableProducts(productsArray, customer);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)("id"), function(productIdsToLoad) {
        return actions.price.load(productIdsToLoad, customer, {
            date: (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate)
        });
    })((0,_utils_get_saleable_product_ids__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)());
};
// @ts-expect-error - Automatic, Please fix when editing this file
var componentWillReceiveProps = function(thisProps, nextProps) {
    var thisDate = (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(thisProps.useFutureEffectiveDate);
    var nextDate = (0,_utils_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(nextProps.useFutureEffectiveDate);
    // Load prices for available products if the prop change could change pricing.
    var customerChange = ___WEBPACK_IMPORTED_MODULE_3__/* ["default"].getKey */ .Z.getKey("", thisProps.customer, {
        date: thisDate
    }) !== ___WEBPACK_IMPORTED_MODULE_3__/* ["default"].getKey */ .Z.getKey("", nextProps.customer, {
        date: nextDate
    });
    var changedProducts = !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEqual)(thisProps.products, nextProps.products);
    if (customerChange || changedProducts) {
        var customer = nextProps.customer, products = nextProps.products, useFutureEffectiveDate = nextProps.useFutureEffectiveDate;
        var actions = thisProps.actions; // Not sure why this isn’t from next props
        componentDidMount({
            actions: actions,
            customer: customer,
            products: products,
            useFutureEffectiveDate: useFutureEffectiveDate
        });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    componentDidMount: componentDidMount,
    componentWillReceiveProps: componentWillReceiveProps
});


/***/ }),

/***/ 42070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22222);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99846);
/* harmony import */ var _select_raw_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96980);




var makeSelectHasAllRequiredProductsLoaded = function(productList) {
    return (0,reselect__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
        _select_raw_product__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
    ], function(products) {
        var loadedProductIds = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flow)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.pick)([
            "data"
        ]), (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.flatMap)(lodash_fp__WEBPACK_IMPORTED_MODULE_1__.keys))(products);
        var allLoaded = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.every)(function(productId) {
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.includes)(productId, loadedProductIds);
        }, productList);
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'error' does not exist on type 'never'.
        if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(products === null || products === void 0 ? void 0 : products.error)) {
            var ref;
            _logging__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getLogger */ .Z.getLogger().error("All required products haven’t loaded", {
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'error' does not exist on type 'never'.
                error: (ref = products === null || products === void 0 ? void 0 : products.error) !== null && ref !== void 0 ? ref : null
            });
        }
        var ref1, ref2;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'loading' does not exist on type 'never'.
        return allLoaded && (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((ref1 = products === null || products === void 0 ? void 0 : products.loading) !== null && ref1 !== void 0 ? ref1 : false) || !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isEmpty)((ref2 = products === null || products === void 0 ? void 0 : products.error) !== null && ref2 !== void 0 ? ref2 : null);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (makeSelectHasAllRequiredProductsLoaded);


/***/ }),

/***/ 50359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _select_raw_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96980);

var ref;
// @ts-expect-error - Automatic, Please fix when editing this file
var selectProductsError = function(state) {
    var ref1;
    return (ref = (ref1 = (0,_select_raw_product__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(state)) === null || ref1 === void 0 ? void 0 : ref1.error) !== null && ref !== void 0 ? ref : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectProductsError);


/***/ }),

/***/ 84701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47569);

var getFutureDate = function(useFutureEffectiveDate) {
    return useFutureEffectiveDate ? _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FUTURE_EFFECTIVE_DATE */ .Z.FUTURE_EFFECTIVE_DATE : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFutureDate);


/***/ }),

/***/ 591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);


// @ts-expect-error - Automatic, Please fix when editing this file
var isProductBestSeller = function(param) {
    var scale = param.scale, parentProductId = param.parentProductId, productId = param.productId, productType = param.productType;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly hospital: { readonly single: "starter-bronze"; readonly couple: "simple-bronze-plus"; readonly family: "essentials-silver-plus"; readonly "single-parent": "core-bronze-plus"; }; readonly extras: { ...; }; readonly package: { ...; }; }'.
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.some)(function(id) {
        var ref;
        return id === (_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === null || _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === void 0 ? void 0 : (ref = _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST[productType]) === null || ref === void 0 ? void 0 : ref[scale]);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        parentProductId,
        productId
    ]));
};
/* harmony default export */ __webpack_exports__["Z"] = (isProductBestSeller);


/***/ }),

/***/ 59794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export serviceMapper */
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(591);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26789);





// @ts-expect-error - Automatic, Please fix when editing this file
var serviceMapper = function(feature) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(param) {
        var id = param.id, name = param.name;
        return {
            id: id,
            name: name
        };
    }, feature.services);
};
var prepareProductForProductTile = function(param) {
    var customer = param.customer, frequency = param.frequency, prices = param.prices, mlsAmount = param.mlsAmount, useFutureEffectiveDate = param.useFutureEffectiveDate;
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(product) {
        var ref;
        if (!product) {
            return null;
        }
        var id = product.id, additionalDetails = product.additionalDetails, charges = product.charges, content = product.content, ctaText = product.ctaText, extras = product.extras, features = product.features, hospital = product.hospital, hospitalTier = product.hospitalTier, name = product.name, rank = product.rank, type = product.type, ctaProductId = product.ctaProductId, parentProductId = product.parentProductId, unavailableWithExcessInfo = product.unavailableWithExcessInfo;
        var scale = customer.scale;
        var date = (0,_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate);
        var price = _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getPrice */ .Z.getPrice(prices, id, customer, {
            date: date
        });
        var priceObject = price ? _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getAmountAsObject */ .Z.getAmountAsObject(price, frequency) : undefined;
        var saving = mlsAmount && priceObject ? Math.max(mlsAmount - parseFloat("".concat(priceObject.dollars, ".").concat(priceObject.cents)), 0) : undefined;
        var ref1;
        var hospitalFeatured = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.hospital) === null || ref === void 0 ? void 0 : ref.featured) !== null && ref1 !== void 0 ? ref1 : [];
        var hospitalServices = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(serviceMapper, hospitalFeatured);
        return {
            additionalDetails: additionalDetails,
            charges: charges,
            content: content,
            ctaText: ctaText,
            extras: extras,
            features: features,
            frequency: frequency,
            hospital: hospital,
            hospitalTier: hospitalTier,
            id: id,
            isAvailable: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scale, product.scales.supported),
            isBestSeller: (0,_is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                parentProductId: parentProductId,
                productId: id,
                productType: type,
                scale: scale
            }),
            name: name,
            price: priceObject,
            rank: rank,
            saving: saving,
            scale: customer.scale,
            services: hospitalServices,
            type: type,
            unavailableWithExcessInfo: unavailableWithExcessInfo,
            url: _models_url__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProductUrl */ .Z.getProductUrl(ctaProductId || id)
        };
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductForProductTile);



/***/ }),

/***/ 97189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","withBorders":"styles_withBorders__jpuBF"};

/***/ }),

/***/ 7550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__Vrua0"};

/***/ }),

/***/ 90937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__LLK5Q"};

/***/ }),

/***/ 74701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","cta":"styles_cta__3jM4X","centeredBlock":"styles_centeredBlock__oAIPA"};

/***/ }),

/***/ 42262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__O7WkK","horizontalSpacingWrapper":"styles_horizontalSpacingWrapper__zwDaO","invert":"styles_invert__K85Fh","wide":"styles_wide__gsza_"};

/***/ }),

/***/ 84514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","calculatorWrapper":"styles_calculatorWrapper__sqrr1","medicareLink":"styles_medicareLink__EgEmM","paragraphBreak":"styles_paragraphBreak__iozZP"};

/***/ }),

/***/ 68255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","value":"styles_value__SmaMg"};

/***/ }),

/***/ 43738:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","calculator":"styles_calculator__gdJTj","sliderContainer":"styles_sliderContainer__b_9VA","fieldsWrapper":"styles_fieldsWrapper__1kgMA","field":"styles_field__QfHwF"};

/***/ }),

/***/ 6069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__h4RpF"};

/***/ }),

/***/ 47288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","wrapper":"styles_wrapper__dduTY","section":"styles_section__ygqpS","or":"styles_or__R6z_D","disclaimerContainer":"styles_disclaimerContainer__OPiN8","productTiles":"styles_productTiles__5AiUN","productTileWrapper":"styles_productTileWrapper__Xds7Z","buttonWrapper":"styles_buttonWrapper__kmfTA","productTileCol":"styles_productTileCol__ZWqsS","productTile":"styles_productTile__94hXC","cta":"styles_cta__ZGN6_"};

/***/ }),

/***/ 58779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","withDollarSignsBackground":"styles_withDollarSignsBackground__O_DjQ"};

/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1372,1849,9143,7022,9774,2888,179], function() { return __webpack_exec__(86151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);